import { inject, Injectable } from '@angular/core';
import { PreisIndikation, PriceSheet } from '@mwe/models';
import { SessionStorage, SessionStorageService } from '@mwe/utils';
import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';

const indicationsKey = 'order_indications';
const priceSheetsKey = 'order_priceSheets';
const tariffOptionsFormPopupAlreadyOpenedForKey = 'tariff-selection_tariffOptionsFormPopupAlreadyOpenedFor';

@Injectable({ providedIn: 'root' })
export class TariffSelectionStateService {
  private storage = inject(SessionStorageService);

  @SessionStorage(indicationsKey)
  private _indications: PreisIndikation[];

  @SessionStorage(priceSheetsKey)
  private _priceSheets: PriceSheet[];

  @SessionStorage(tariffOptionsFormPopupAlreadyOpenedForKey)
  private _tariffOptionsFormPopupAlreadyOpenedFor: string[];

  clearData(): void {
    this.storage.clear(indicationsKey);
    this.storage.clear(priceSheetsKey);
    this.storage.clear(tariffOptionsFormPopupAlreadyOpenedForKey);
  }

  get priceSheets(): PriceSheet[] {
    return this._priceSheets ?? [];
  }

  set priceSheets(priceSheets: PriceSheet[]) {
    this._priceSheets = priceSheets?.filter(i => i);
  }

  get indications(): PreisIndikation[] {
    return this._indications ?? [];
  }

  set indications(indications: PreisIndikation[]) {
    this._indications = indications?.filter(i => i);
  }

  get tariffOptionsFormPopupAlreadyOpenedFor(): string[] {
    return this._tariffOptionsFormPopupAlreadyOpenedFor ?? [];
  }

  set tariffOptionsFormPopupAlreadyOpenedFor(value: string[]) {
    this._tariffOptionsFormPopupAlreadyOpenedFor = value;
  }

  priceSheetObserver(): Observable<PriceSheet[]> {
    return this.storage.observe<PriceSheet[]>(priceSheetsKey).pipe(startWith(this.priceSheets || undefined));
  }
}
